import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/axios';

export const useNotifications = () => {
    return useQuery({
        queryKey: ['notifications'],
        queryFn: async () => {
            const response = await apiClient.get('/notifications');
            return response.data;
        },
        refetchInterval: 10 * 60 * 1000, // 10 minutes (600000 ms)

    });
};